export function linear(t) {
  return +t;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.7@d3-ease/src/linear.js
// module id = 143
// module chunks = 0